import React, { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import MfaEnrollmentRequired from './MfaEnrollmentRequired';
import MfaUnavailable from './MfaUnavailable';
import StandaloneSurface from '../../../components/Layout/StandaloneSurface';

const AuthWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading, mfaStatus } = useAuth();
  const [isSignUp, setIsSignUp] = useState(false);
  const [showEnrollmentRequired, setShowEnrollmentRequired] = useState(false);

  if (loading) {
    return (
      <StandaloneSurface measure="reading" aria-busy="true">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </StandaloneSurface>
    );
  }

  // Show MFA enrollment required screen
  if (mfaStatus === 'enroll_required' || showEnrollmentRequired) {
    return <MfaEnrollmentRequired />;
  }

  if (mfaStatus === 'unavailable') {
    return <MfaUnavailable />;
  }

  if (!isAuthenticated) {
    return isSignUp ? (
      <SignUpForm onToggleMode={() => setIsSignUp(false)} />
    ) : (
      <LoginForm
        onToggleMode={() => setIsSignUp(true)}
        onMfaEnrollRequired={() => setShowEnrollmentRequired(true)}
      />
    );
  }

  return <>{children}</>;
};

export default AuthWrapper;
